// Community CCTV Management APIs

/**
 * @function ApiClient#GetMediaSourceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetMediaSourceList(cid, options = {}) {
  return await this._get(`/community/${cid}/cctv/media_source_list`, options);
}

/**
 * @function ApiClient#AddMediaSource
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} ms
 * @param {any} options = {}
 */
export async function AddMediaSource(cid, ms, options = {}) {
  return await this._post(`/community/${cid}/cctv/media_source`, ms, options);
}

/**
 * @function ApiClient#UpdateMediaSource
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} ms
 * @param {any} options = {}
 */
export async function UpdateMediaSource(cid, ms, options = {}) {
  return await this._put(`/community/${cid}/cctv/media_source`, ms, options);
}

/**
 * @function ApiClient#RequestVideo
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} msid
 * @param {any} uuid
 * @param {any} sdp
 * @param {any} enableTrickleIce = false
 * @param {any} options = {}
 */
export async function RequestVideo(cid, msid, uuid, sdp, enableTrickleIce = false, options = {}) {
  const formData = new FormData();
  formData.set("uuid", uuid);
  formData.set("sdp", sdp);
  formData.set("enableTrickleIce", enableTrickleIce ? "true" : "false");

  return await this._post(`/community/${cid}/cctv/${msid}/request`, formData, options);
}

/**
 * @function ApiClient#SendCandidate
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uuid
 * @param {any} candidate
 * @param {any} options = {}
 */
export async function SendCandidate(cid, uuid, candidate, options = {}) {
  const formData = new FormData();
  formData.set("uuid", uuid);
  formData.set("candidate", candidate);

  return await this._post(`/community/${cid}/cctv/candidate`, formData, options);
}
